module.exports = __webpack_public_path__ + "img/11_28.4eed83cf.png";